import React, { useState } from "react";
import { Bell, BellOff, Megaphone, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const LEVELS = [
  { key: "all", label: "All posts", hint: "Every new post, announcement & pin", Icon: Bell },
  { key: "announce", label: "Announcements only", hint: "Just announcements & pinned posts", Icon: Megaphone },
  { key: "off", label: "Off", hint: "No alerts from this community", Icon: BellOff },
];

// Per-member alert preference for one Hearth.
export const HearthNotifyMenu = ({ hearthId, level, onChange }) => {
  const [open, setOpen] = useState(false);
  const cur = LEVELS.find((l) => l.key === level) || LEVELS[0];
  const pick = async (k) => {
    setOpen(false);
    if (k === level) return;
    const prev = level;
    onChange(k);
    try { await api.put(`/hearths/${hearthId}/notify`, { level: k }); toast.success(`Alerts: ${LEVELS.find((l) => l.key === k).label}`); }
    catch { onChange(prev); toast.error("Couldn't update alerts, try again"); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="hearth-notify-btn" aria-label="Community alerts" title={`Alerts: ${cur.label}`}
          className="flex items-center gap-1.5 border border-white/15 text-zinc-300 hover:text-white hover:bg-white/5 px-3 py-2 font-body text-xs transition-colors">
          <cur.Icon size={14} /> <span className="hidden sm:inline">{cur.label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-1.5 bg-[#121212] border-white/15" data-testid="hearth-notify-menu">
        <div className="px-2 py-1.5 font-body text-[10px] tracking-[0.15em] uppercase text-zinc-500">Alerts from this community</div>
        {LEVELS.map(({ key, label, hint, Icon }) => (
          <button key={key} type="button" onClick={() => pick(key)} data-testid={`hearth-notify-${key}`}
            className="w-full flex items-start gap-2.5 px-2 py-2 text-left hover:bg-white/5 transition-colors">
            <Icon size={15} className="mt-0.5 text-[#14A89A] shrink-0" />
            <span className="flex-1 min-w-0"><span className="block font-body text-sm text-white">{label}</span><span className="block font-body text-[11px] text-zinc-500">{hint}</span></span>
            {key === level && <Check size={14} className="mt-0.5 text-[#14A89A] shrink-0" />}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
